  const Apiurl = 'https://bs.aalantechsoft.com:5007/api'
//const Apiurl = 'http://localhost:8000/api'
//const Apiurl = 'http://192.168.1.241:8000/api'

export default Apiurl